import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  host: { 'test-id': 'add-data-dialog-alert' },
  selector: 'add-data-dialog-alert',
  styleUrls: ['./add-data-dialog-alert.component.scss'],
  templateUrl: './add-data-dialog-alert.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class AddDataDialogAlert {
  @Input() errorMessage: string;
}
